import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=64a7a2cf&scoped=true&lang=pug&"
import script from "./CreateButton.vue?vue&type=script&lang=ts&"
export * from "./CreateButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateButton.vue?vue&type=style&index=0&id=64a7a2cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7a2cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
